import { ReferentialKey } from 'api/referential';
import { useAppDispatch } from 'app/hooks';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { NsKey } from 'enums/NsKey';
import { getMultipleReferentialsByKeys } from 'features/referentials/slices/getMultipleReferentialsByKeysThunk';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { Package } from 'lucide-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function GroupContractView() {
  const { t } = useDynamicTranslation([NsKey.Common])
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getMultipleReferentialsByKeys([
      ReferentialKey.Branch,
      ReferentialKey.Plateforme,
      ReferentialKey.ContractPeriodicity,
      ReferentialKey.NoticeUnit,
    ]))
  }, [dispatch])

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title={t("SIDEBAR.GROUP_CONTRACT_MANAGER")}
        icon={Package}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
